import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class InstantSalesViewActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/InstantTrx/InstantTrxBrowser")
	}

	render() {
		return (
			<Activity 
				name="InstantSales"
				RenderedComponent={this.RenderedComponent}
				context="sales"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(InstantSalesViewActivity)
